/**
 * Контрагенты — справочник (поставщики/заказчики).
 */
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { Spinner } from "@/components/Spinner";
import { fetchContractors, CUSTOMER_KIND_LABEL } from "@/api/warehouse";
import { ApiError } from "@/api/client";


const KIND_LABELS: Record<string, string> = {
  supplier: "Поставщик",
  customer: "Заказчик",
  both:     "Оба",
};


export function WarehouseContractorsPage() {
  const [kindFilter, setKindFilter] = useState<"" | "supplier" | "customer" | "both">("");

  const q = useQuery({
    queryKey: ["warehouse-contractors", kindFilter],
    queryFn: () => fetchContractors({ kind: kindFilter || undefined }),
  });

  if (q.isLoading) return <Spinner size="lg" label="Загрузка контрагентов…" />;
  if (q.error) {
    const err = q.error;
    if (err instanceof ApiError && err.status === 403) {
      return <div className="alert alert-amber"><div className="alert-body">Доступ ограничен</div></div>;
    }
    return <div className="alert alert-red"><div className="alert-body">{(err as Error).message}</div></div>;
  }
  const items = q.data || [];

  return (
    <div className="page">

      <div className="filter-bar" style={{ marginBottom: "var(--gap)" }}>
        <div className="chip-row">
          <button className={`chip ${!kindFilter ? "active" : ""}`} onClick={() => setKindFilter("")}>Все</button>
          <button className={`chip ${kindFilter === "supplier" ? "active" : ""}`} onClick={() => setKindFilter("supplier")}>Поставщики</button>
          <button className={`chip ${kindFilter === "customer" ? "active" : ""}`} onClick={() => setKindFilter("customer")}>Заказчики</button>
        </div>
      </div>

      {items.length === 0 ? (
        <div className="card" style={{ textAlign: "center", padding: "32px 20px" }}>
          <div className="muted">Контрагентов не найдено</div>
          <div style={{ fontSize: 12, color: "var(--mute)", marginTop: 8 }}>
            В импортированной экселке справочник почти пустой — реальные имена приходят строкой в шапках накладных.
            Можно посмотреть их через топ-листы в Сводке.
          </div>
        </div>
      ) : (
        <div className="card">
          <div className="tbl-scroll">
            <table className="tbl">
              <thead>
                <tr>
                  <th>Название</th>
                  <th style={{ width: 130 }}>Тип</th>
                  <th style={{ width: 130 }}>Подтип (заказчик)</th>
                  <th style={{ width: 90 }} title="Дни доставки от поставщика — для расчёта ожидаемой даты прихода">Lead, дн</th>
                  <th>Адрес</th>
                  <th style={{ width: 160 }}>Телефон</th>
                </tr>
              </thead>
              <tbody>
                {items.map(c => (
                  <tr key={c.id}>
                    <td className="strong">{c.name}</td>
                    <td><span className="badge">{KIND_LABELS[c.kind] || c.kind}</span></td>
                    <td>
                      {c.customer_kind
                        ? <span className="badge">{CUSTOMER_KIND_LABEL[c.customer_kind]}</span>
                        : <span className="muted">—</span>}
                    </td>
                    <td className="tabular num">
                      {c.default_lead_days ?? <span className="muted">—</span>}
                    </td>
                    <td>{c.address || <span className="muted">—</span>}</td>
                    <td className="tabular">{c.phone || <span className="muted">—</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
